const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;

// An empty field counts as zero, so "30 min before" needs no leading "0" in the hours field.
const parseField = (value: string): number | null => {
  const trimmed = value.trim();

  if (!trimmed.length) {
    return 0;
  }

  return /^\d+$/.test(trimmed) ? Number(trimmed) : null;
};

// Authored as separate hour + minute fields; null when neither field holds a usable number.
export const parseRelativeReminderOffset = (
  hours: string,
  minutes: string,
): number | null => {
  if (!hours.trim().length && !minutes.trim().length) {
    return null;
  }

  const parsedHours = parseField(hours);
  const parsedMinutes = parseField(minutes);

  if (parsedHours === null || parsedMinutes === null) {
    return null;
  }

  const duration = parsedHours * MS_PER_HOUR + parsedMinutes * MS_PER_MINUTE;

  return duration === 0 ? 0 : -duration;
};
